//constants
import {TICKETS_INFO, PAYMENT, ATTENDEES_INFO} from '@/utils/constants';
//form configuration
import {AddTableTicketFormValues} from './formConfiguration';
import {PAYMENT_METHOD, STORAGE_KEY} from '@/utils/enums';
import { userStorage } from '@/utils/services';

export const addTableTicketSteps = [`1. ${TICKETS_INFO}`, `2. ${PAYMENT}`, `3. ${ATTENDEES_INFO}`];

export enum ADD_TABLE_TICKET_STEP {
	TICKET_INFO,
	PAYMENT,
	ATTENDEES_INFO,
}

export const getNewTableTicketValues = (tableAndTicketValues: AddTableTicketFormValues) => {
	const token = userStorage.get(STORAGE_KEY.PRIVATE_PURCHASE_TOKEN);
	const newValues: AddTableTicketFormValues = {
		...tableAndTicketValues,
		purchaser: {
			...tableAndTicketValues.purchaser,
			phoneNumber: String(tableAndTicketValues.purchaser.phoneNumber),
			isUnknown: false,
		},
		isPaid: tableAndTicketValues.paymentOption === PAYMENT_METHOD.CASH_OR_CHECK,
		isCoverFee:
			tableAndTicketValues.paymentOption === PAYMENT_METHOD.CREDIT_CARD && tableAndTicketValues.isCoverFee,
		...(token ? {privatePurchaseToken: token} : {}),
		setTables: tableAndTicketValues.setTables.map(({purchaserIsNotAttending, ...table}) => ({
			...table,

			attendees: table.attendees.map(({meals, phoneNumber, ...attendee}) => {
				const hasData = !!(attendee.firstName?.trim() && attendee.lastName?.trim());

				return {...attendee, phoneNumber: String(phoneNumber), meals, isUnknown: !hasData};
			}),
		})),
	};

	return newValues;
};
